export const PORTAL_ADMIN_ROLE_CODES = ["slt", "dev"] as const;

export function canAccessPortalAdministration(
	roles: string[],
	permissions: string[] = [],
) {
	return (
		permissions.some(
			(permission) => permission.toLowerCase() === "timetables.manage",
		) ||
		roles.some((role) =>
			PORTAL_ADMIN_ROLE_CODES.includes(
				role as (typeof PORTAL_ADMIN_ROLE_CODES)[number],
			),
		)
	);
}
